import React from 'react';

const Hexagon = (props) => (
  <div style={{"height": "75px"}}>
    <div style={{"height": "75px"}}>
      <div className="hexagon"></div>
      <i className={props.icon}></i>
    </div>
  </div>
);

export default Hexagon;



// WEBPACK FOOTER //
// ./src/components/About/components/Hexagon/index.js